module.exports = __webpack_public_path__ + "static/media/tinyaddemoji.add289bf.png";